import { AggregationMode, KeyValuePair } from '../models';

export const aggregationModes: KeyValuePair<AggregationMode, string>[] = [
    { key: AggregationMode.None, value: 'None' },
    { key: AggregationMode.Average, value: 'Average' },
    { key: AggregationMode.Sum, value: 'Sum' },
    { key: AggregationMode.Minimum, value: 'Minimum' },
    { key: AggregationMode.Maximum, value: 'Maximum' },
    { key: AggregationMode.First, value: 'First' },
    { key: AggregationMode.Last, value: 'Last' },
    // commented for now as not implemented in backend
    //{ key: AggregationMode.StdDev, value: 'Standard deviation' },
    { key: AggregationMode.Delta, value: 'Delta' },
    { key: AggregationMode.Integration, value: 'Integral' }
];